export const PayRequestDashboardConstant = {
  headerConfig: {
    title: "Provider Dashboard",
    id: "provider-dashboard",
  },

  periodFilters: [
    { text: "PYTD", value: "PYTD" },
    { text: "YTD", value: "YTD" },
    { text: "Monthly", value: "Monthly" },
    { text: "Weekly", value: "Weekly" },
    { text: "Daily", value: "Daily" },
  ],

  tabLabels: {
    pending: "Pending",
    approved: "Approved",
    rejected: "Rejected",
  },

  chartColors: {
    shifts: "#4CAF50",
    onCall: "#2196F3",
    cme: "#FF5722",
    leadership: "#9C27B0",
    medicalDirectorship: "#FF9800",
    clinicalServices: "#E91E63",
  },

  statusColors: {
    pending: "#2196F3",
    approved: "#4CAF50",
    rejected: "#f44336",
  },
};
